import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './index.css';
import Footer from '../About/Footer';
const Revenue = () => {
    const [openFaq, setOpenFaq] = useState(null);

    const toggleFaq = (index) => {
        setOpenFaq(openFaq === index ? null : index);
    };

    const points = [
        { num: '01', text: 'What is the starting baseline?' },
        { num: '02', text: 'Which revenue counts?' },
        { num: '03', text: 'How is it attributed?' },
        { num: '04', text: 'What do both sides commit?' },
        { num: '05', text: 'How does the share work?' },
        { num: '06', text: 'How can either side exit?' }
    ];

    const steps = [
        { num: '01', title: 'Diagnose', tag: 'WEEK 01', isHighlight: false },
        { num: '02', title: 'Design', tag: 'WEEK 02', isHighlight: false },
        { num: '03', title: 'Execute', tag: 'WEEK 03+', isHighlight: false },
        { num: '04', title: 'Measure & share', tag: 'MONTHLY', isHighlight: true }
    ];

    const faqs = [
        {
            q: 'Is Revenue Exchange the same as equity?',
            a: 'No. Revenue Exchange is a commercial revenue-sharing arrangement, not an investment or transfer of company ownership. Any discussion about equity would be separate, explicit and governed by its own agreement.'
        },
        {
            q: 'Is there an upfront fee?',
            a: 'The commercial structure depends on the scope of the partnership. Some engagements may include a modest setup or operating fee alongside the performance-based component. Any fees, direct costs and responsibilities are agreed upon before work begins.'
        },
        {
            q: 'What percentage do you take?',
            a: 'There is no universal percentage. The revenue share depends on factors such as your margins, sales cycle, the work involved, MarkoKnow’s contribution, attribution complexity and the level of risk being shared. Your proposal will clearly show the exact percentage, applicable revenue and worked examples.'
        },
        {
            q: 'What if the growth comes from somewhere else?',
            a: 'Revenue that falls outside the agreed customers, campaigns, channels or attribution rules is excluded from the exchange. We establish a baseline, use a shared reporting system and reconcile the numbers regularly so both sides can see exactly which revenue qualifies.'
        },
        {
            q: 'How long is a partnership?',
            a: 'The partnership must run long enough to test, learn and build momentum. The exact pilot period, renewal process, notice requirements and post-exit attribution window are defined in the partnership agreement before kickoff.'
        }
    ];

    return (
        <div className="mk-landing-page">
            {/* 1. NAVBAR */}
            <nav className="mk-navbar">
                <div className="mk-nav-brand">
                    <div className="mk-logo-badge">mk</div>
                    <span className="mk-brand-name">markoknow</span>
                </div>
                <div className="mk-nav-right">
                    <div className="mk-nav-links">
                        <a href="#model" className="mk-nav-link">The model</a>
                        <a href="#what-we-do" className="mk-nav-link">What we do</a>
                        <a href="#who-its-for" className="mk-nav-link">Who it's for</a>
                    </div>
                    <button className="mk-partnership-btn">
                        Explore a partnership ↗
                    </button>
                </div>
            </nav>

            {/* 2. HERO SECTION */}
            <section className="mk-hero">
                <div className="mk-hero-left">
                    <div className="mk-subheading-tag">
                        <span className="mk-tag-dot"></span>
                        Revenue Exchange by MarkoKnow
                    </div>

                    <h1 className="mk-hero-heading">
                        You grow.<br />
                        We earn<br />
                        <span className="mk-heading-italic">together.</span>
                    </h1>

                    <p className="mk-hero-desc">
                        A hands-on growth partnership for ambitious startups. We bring the strategy, talent and founder network. You share a portion of the new revenue we help create.
                    </p>

                    <div className="mk-hero-cta-group">
                        <Link to="/revenueform" className="mk-primary-btn" style={{ textDecoration: 'none' }}>
                            Build with us ↗
                        </Link>
                        <a href="#how-it-runs" className="mk-secondary-link">
                            See how the exchange works ↓
                        </a>
                    </div>
                </div>

                <div className="mk-hero-right">
                    <div className="mk-badge-tag mk-badge-top">
                        ALIGNED INCENTIVES
                    </div>

                    <div className="mk-circle-graphic">
                        <div className="mk-outer-ring ring-3"></div>
                        <div className="mk-outer-ring ring-2"></div>
                        <div className="mk-outer-ring ring-1"></div>

                        <div className="mk-center-circle">
                            <span className="mk-circle-sub">THE EXCHANGE</span>
                            <span className="mk-circle-plus">+</span>
                            <p className="mk-circle-text">
                                Our growth engine<br />meets your product
                            </p>
                        </div>
                    </div>

                    <div className="mk-badge-tag mk-badge-bottom">
                        MEASURED MONTHLY
                    </div>
                </div>
            </section>

            {/* 3. THE MODEL SECTION */}
            <section className="mk-model-section" id="model">
                <div className="mk-section-header">
                    <div className="mk-subheading-tag">
                        <span className="mk-tag-dot"></span>
                        01 THE MODEL
                    </div>
                    <h2 className="mk-section-heading">
                        Less vendor.<br />
                        More <span className="mk-heading-italic">skin in the game.</span>
                    </h2>
                </div>

                <div className="mk-formula-grid">
                    <div className="mk-formula-card card-purple">
                        <span className="mk-card-tag">YOU BRING</span>
                        <p className="mk-card-text">A strong product and the will to scale.</p>
                    </div>

                    <div className="mk-operator">+</div>

                    <div className="mk-formula-card card-light">
                        <span className="mk-card-tag">WE BRING</span>
                        <p className="mk-card-text">A focused team built around growth.</p>
                    </div>

                    <div className="mk-operator">=</div>

                    <div className="mk-formula-card card-dark">
                        <span className="mk-card-tag">WE CREATE</span>
                        <p className="mk-card-text">New, attributable revenue to share.</p>
                    </div>
                </div>
            </section>

            {/* 4. WHAT GETS EXPLAINED SECTION */}
            <section className="mk-explained-section">
                <div className="mk-explained-left">
                    <div className="mk-subheading-tag">
                        <span className="mk-tag-dot"></span>
                        03 WHAT GETS EXPLAINED
                    </div>

                    <h2 className="mk-section-heading">
                        No mystery<br />
                        maths.<br />
                        <span className="mk-heading-italic">Clarity before kickoff.</span>
                    </h2>

                    <p className="mk-explained-desc">
                        We break down the key mechanics of your Revenue Exchange so both sides start aligned, informed, and ready to build.
                    </p>

                    <div className="mk-memo-card">
                        <div className="mk-memo-icon">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#5c4eb4" strokeWidth="2">
                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                <polyline points="14 2 14 8 20 8"></polyline>
                                <line x1="16" y1="13" x2="8" y2="13"></line>
                                <line x1="16" y1="17" x2="8" y2="17"></line>
                            </svg>
                        </div>
                        <div>
                            <span className="mk-memo-tag">PARTNERSHIP MEMO</span>
                            <p className="mk-memo-sub">— One shared source of truth</p>
                        </div>
                    </div>
                </div>

                <div className="mk-explained-right">
                    {points.map((item, idx) => (
                        <div key={idx} className="mk-point-row">
                            <span className="mk-point-num">{item.num}</span>
                            <span className="mk-point-divider">|</span>
                            <span className="mk-point-text">{item.text}</span>
                        </div>
                    ))}
                </div>
            </section>

            {/* 5. HOW IT RUNS SECTION */}
            <section className="mk-runs-section" id="how-it-runs">
                <div className="mk-section-header">
                    <div className="mk-subheading-tag">
                        <span className="mk-tag-dot"></span>
                        04 HOW IT RUNS
                    </div>
                    <h2 className="mk-section-heading">
                        From bottleneck<br />
                        to <span className="mk-heading-italic">breakthrough.</span>
                    </h2>
                </div>

                <div className="mk-steps-container">
                    {steps.map((step, idx) => (
                        <div
                            key={idx}
                            className={`mk-step-card ${step.isHighlight ? 'step-purple' : 'step-white'}`}
                        >
                            <div className="mk-step-num">{step.num}</div>
                            <hr className="mk-step-hr" />
                            <div className="mk-step-title">{step.title}</div>
                            <div className="mk-step-tag">{step.tag}</div>
                            {idx < steps.length - 1 && <div className="mk-step-arrow"></div>}
                        </div>
                    ))}
                </div>
            </section>

            {/* 6. COMMON QUESTIONS SECTION */}
            <section className="mk-faq-section">
                <div className="mk-faq-left">
                    <div className="mk-subheading-tag">
                        <span className="mk-tag-dot"></span>
                        06 COMMON QUESTIONS
                    </div>

                    <h2 className="mk-section-heading">
                        Good questions.<br />
                        <span className="mk-heading-italic">Straight answers.</span>
                    </h2>

                    <p className="mk-faq-desc">
                        Clear answers to common questions about how Revenue Exchange works.
                    </p>
                </div>

                <div className="mk-faq-right">
                    {faqs.map((faq, idx) => (
                        <div
                            key={idx}
                            className={`mk-faq-row ${openFaq === idx ? 'open' : ''}`}
                            onClick={() => toggleFaq(idx)}
                        >
                            <div className="mk-faq-header">
                                <span className="mk-faq-title">{faq.q}</span>
                                <span className="mk-faq-plus">{openFaq === idx ? '−' : '+'}</span>
                            </div>
                            {openFaq === idx && (
                                <p className="mk-faq-ans">{faq.a}</p>
                            )}
                        </div>
                    ))}
                </div>
            </section>

            {/* 7. START THE EXCHANGE SECTION */}
            <section className="mk-cta-section">
                <div className="mk-cta-content">
                    <span className="mk-cta-tag">07 START THE EXCHANGE</span>

                    <h2 className="mk-cta-heading">
                        Bring the product.<br />
                        We'll bring the <span className="mk-cta-italic">growth room.</span>
                    </h2>

                    <p className="mk-cta-sub">
                        Start with a 30-minute fit conversation.
                    </p>

                    <button className="mk-cta-button">
                        Talk to MarkoKnow <span className="mk-arrow">↗</span>
                    </button>

                    <a href="mailto:hello@markoknow.com" className="mk-cta-email">
                        hello@markoknow.com
                    </a>
                </div>
            </section>
            <Footer />
        </div>
    );
};

export default Revenue;